/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { EuiFieldText, EuiFormRow } from "@inscopix/ideas-eui";
import { DEFAULT_FOLDER_COLOR } from "components/ProjectTablesTable/ProjectTablesTable.helpers";

interface FieldFolderNameProps {
  autoFocus?: boolean;
  label?: string;
  placeholder?: string;
  value: string;
  color: string | null;
  colorIsValid: boolean;
  onChange: (field: { value: string; isValid: boolean }) => void;
}

export const FieldFolderName = ({
  autoFocus,
  label = "Name",
  placeholder = "",
  value,
  color,
  colorIsValid,
  onChange,
}: FieldFolderNameProps) => {
  return (
    <EuiFormRow
      fullWidth
      label={label}
      css={
        colorIsValid
          ? css`
              color: ${color != null ? color : DEFAULT_FOLDER_COLOR}!important;
            `
          : undefined
      }
    >
      <EuiFieldText
        aria-label="Folder name"
        placeholder={placeholder}
        value={value}
        onChange={(e) => {
          const newName = e.target.value;
          onChange({
            value: newName,
            isValid: newName !== "",
          });
        }}
        icon="folderOpen"
        maxLength={255}
        isInvalid={false}
        autoFocus={autoFocus}
        css={
          colorIsValid
            ? css`
                color: ${color != null
                  ? color
                  : DEFAULT_FOLDER_COLOR}!important;
              `
            : undefined
        }
      />
    </EuiFormRow>
  );
};
